import React, { memo } from 'react';

import Headline from 'components/Headline/Headline';
import SocialMediaTile, {
  SocialMediaTileProps,
} from 'components/SocialMediaTile/SocialMediaTile';
import useOverElement from 'hooks/useOverElement';

import * as S from '../AboutPage.styles';

export interface SocialMediaSectionProps {
  title: string;
  socialMediaCards: Array<SocialMediaTileProps>;
}

const SocialMediaSection: React.FunctionComponent<SocialMediaSectionProps> = ({
  title,
  socialMediaCards,
}) => {
  const [ref] = useOverElement();

  const renderCards = socialMediaCards.map(card => (
    <S.SocialMediaCardWrapper key={card.id}>
      <SocialMediaTile {...card} />
    </S.SocialMediaCardWrapper>
  ));

  return (
    <>
      <S.SocialMediaSectionWrapper ref={ref}>
        <S.LeadershipInfo>
          <Headline text={title} size="heading2" />
        </S.LeadershipInfo>

        <S.SocialMediaContentWrapper>
          <S.SocialMediasWrapper>{renderCards}</S.SocialMediasWrapper>
        </S.SocialMediaContentWrapper>
      </S.SocialMediaSectionWrapper>
    </>
  );
};

export default memo(SocialMediaSection);
